import { render, staticRenderFns } from "./ProductCategoryAttributesDialog.vue?vue&type=template&id=7aaefa6d&scoped=true&"
import script from "./ProductCategoryAttributesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryAttributesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoryAttributesDialog.vue?vue&type=style&index=0&id=7aaefa6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaefa6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VCardText,VCheckbox,VCol,VLayout,VRow,VSelect,VTextField,VTextarea})
